import { addDays, format, startOfWeek } from 'date-fns';
import { SocialMediaSelectType } from './social-media-select-type.model';

function daysOfWeek(): SocialMediaSelectType[] {
  const firstDOW = startOfWeek(new Date());
  return Array.from(Array(7)).map((e, i) => ({
    id: i,
    name: format(addDays(firstDOW, i), 'EEEE'),
  }));
}

function hoursOfDay(): SocialMediaSelectType[] {
  const hours: SocialMediaSelectType[] = [];
  for (let hour = 1; hour <= 24; hour += 1) {
    const hourOfDay = {
      id: hour,
      name: `${hour <= 12 ? hour : hour - 12}:00 ${hour < 12 || hour === 24 ? 'AM' : 'PM'}`,
    };

    if (hour < 24) {
      hours.push(hourOfDay);
    } else {
      hours.unshift(hourOfDay);
    }
  }

  return hours;
}

export const SOCIAL_MEDIA_DAYS_OF_WEEK = daysOfWeek();
export const SOCIAL_MEDIA_HOURS_OF_DAY = hoursOfDay();

export const SocialMediaFrequency = {
  Daily: 'Daily',
  Weekly: 'Weekly',
  Disabled: 'Disabled',
} as const;

export type SocialMediaFrequency = (typeof SocialMediaFrequency)[keyof typeof SocialMediaFrequency];

// SAFETY(legacy): unreviewed, pre-dates this rule.
export const SocialMediaFrequencyList = Object.keys(SocialMediaFrequency).map((x) => x as SocialMediaFrequency);
